import React from 'react';
import styled from 'styled-components';
import { graphql } from 'kb-shared';
import { ApolloError } from 'apollo-boost';
import MembershipDetails from './MembershipDetails';
import { InputWrapper, TextInputStyled } from '../steps/styles';
import EnterpriseMembershipTermsDetails from '../components/EnterpriseMembershipTermsDetails';
import Button from '../../../components/Button/NewButton';
import { showErrorToast } from '../../../utilities/notificationUtils';
import { themes } from 'kb-shared';

const Container = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  margin: 0 14px;

  .text-inputs {
    margin-top: 15px;
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;

    .text-input-wrapper {
      margin: 0;
      margin-right: 5px;
      width: 175px;
    }
  }

  .accept-terms-and-submit-wrapper {
    padding: 20px;
    background-color: ${themes.colors.night};
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

type Props = {
  onMembershipCreated: () => void;
  requireUniqueId?: string | null;
};

type State = {
  employerAccessCode: string;
  employeeAccessCode: string;
  termsAreAccepted: boolean;
  loading: boolean;
};

class CreateEnterpriseMembership extends React.Component<Props, State> {
  state: State = {
    employerAccessCode: '',
    employeeAccessCode: '',
    termsAreAccepted: false,
    loading: false
  };

  componentDidMount() {
    if (window.analytics) {
      window.analytics.page('Employee Benefit Activation');
    }
  }

  onSubmit() {
    this.setState(() => ({ loading: true }));
    graphql.client
      .mutate({
        mutation: graphql.mutate.CREATE_PATIENT_ENTERPRISE_MEMBERSHIP,
        variables: {
          employerAccessCode: this.state.employerAccessCode,
          employeeAccessCode: this.state.employeeAccessCode
        }
      })
      .then(this.props.onMembershipCreated)
      .catch(this.handleMutationError.bind(this));
  }

  handleMutationError(err: ApolloError | null) {
    let errString = "We're sorry, something went wrong.";
    if (err) {
      if (err.graphQLErrors.length > 0)
        errString = err.graphQLErrors[0].message.replace('["', '').replace('"]', '');
      else errString = err.message;
    }

    this.setState(() => ({ loading: false }));
    showErrorToast(errString);
  }

  validatedUniqueId(): boolean {
    const { requireUniqueId } = this.props;
    const { employeeAccessCode } = this.state;

    if (requireUniqueId === 'true' && employeeAccessCode === '') {
      return false;
    }

    return true;
  }

  uniqueIdField() {
    const { employeeAccessCode } = this.state;
    const { requireUniqueId } = this.props;

    if (requireUniqueId === 'false') {
      return <></>;
    }

    return (
      <TextInputStyled
        label="UNIQUE ID"
        placeholder={requireUniqueId === 'true' ? 'Required' : 'Optional'}
        value={employeeAccessCode}
        onChange={event => this.setState({ employeeAccessCode: event.currentTarget.value })}
      />
    );
  }

  render() {
    const { employerAccessCode, termsAreAccepted, loading } = this.state;
    const submitButtonIsEnabled =
      employerAccessCode.length > 0 && termsAreAccepted && !loading && this.validatedUniqueId();

    return (
      <Container>
        <MembershipDetails />
        <div className="text-inputs">
          <InputWrapper className="text-input-wrapper">
            <TextInputStyled
              label="ACCESS CODE"
              placeholder="Required"
              value={employerAccessCode}
              onChange={event => this.setState({ employerAccessCode: event.currentTarget.value })}
            />
          </InputWrapper>
          <InputWrapper className="text-input-wrapper">{this.uniqueIdField()}</InputWrapper>
        </div>
        <div className="accept-terms-and-submit-wrapper">
          <EnterpriseMembershipTermsDetails
            selected={termsAreAccepted}
            onCheckBoxSelected={() => this.setState({ termsAreAccepted: !termsAreAccepted })}
          />
          <Button
            loading={false}
            disabled={!submitButtonIsEnabled}
            onClick={() => {
              this.onSubmit();
            }}
            type="submit"
            text="Submit"
          />
        </div>
      </Container>
    );
  }
}

export default CreateEnterpriseMembership;
